import AWSAppSyncClient, { createAppSyncLink } from 'aws-appsync';
import { setContext } from "apollo-link-context";
import { ApolloLink } from "apollo-link";
import { createHttpLink } from "apollo-link-http";
import AppSyncConfig from '../aws-exports';

export const client = new AWSAppSyncClient({
  url: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_graphqlEndpoint,
  region: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_region,
  auth: {
    type: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_authenticationType,
    apiKey: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_apiKey,
    // jwtToken: async () => token, // Required when you use Cognito UserPools OR OpenID Connect. token object is obtained previously
  }
}, {
  defaultOptions: {
    fetchPolicy: 'no-cache'
  },
  link: createAppSyncLink({
    url: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_graphqlEndpoint,
    region: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_region,
    auth: {
      type: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_authenticationType,
      apiKey: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_apiKey,
      // jwtToken: async () => token, // Required when you use Cognito UserPools OR OpenID Connect. token object is obtained previously
    },
    resultsFetcherLink: ApolloLink.from([
      setContext((request, previousContext) => ({
        headers: {
          ...previousContext.headers,
          Authorization: 'Bearer ' + localStorage.getItem('bms_access_token')
        }
      })),
      createHttpLink({
        uri: AppSyncConfig[process.env.REACT_APP_STAGE].aws_appsync_graphqlEndpoint
      })
    ])
  })
})
